<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-03-21 11:49:51
 * @LastEditors: zml
 * @LastEditTime: 2025-09-01 17:11:51
-->
<template>
  <div class="contact-box">
    <div class="images">
      <img src="../../assets/contactus_images1.png" alt style="width: 100%;" />
      <div class="container">
        <div
          class="images_contents"
        >{{ $hs("您可以及时联系我们并提供相关反馈。我们会根据实际情况为您提供免费服务，并且我们的专业售后团队愿意处理此事并为您解决问题。","You Can Contact And Provide Feedback On The Issue In A Timely Manner. We Will Provide You With Free Service Based On The Actual Situation, And OurProfessional After-sales Team Agrees To Handle It And Solve The Problem For You.","") }}</div>
      </div>
    </div>
    <div class="container detail" v-html="$hs(datas.content,datas.enContent,datas.threeContent)"></div>
    <!-- <div class="container locash">
      <img src="../../assets/dizhi.png" alt />
      <div class="loacsh_title">{{ $hs("立丰玩具工业有限公司（义乌唐代贸易公司）","Lifeng Toys Industrial Limited (Yiwu Tang Dai Trading Firm)","") }}</div>
    </div>
    <div class="container locashbox">
      <div class="line"></div>
      <ul>
        <li>{{ $hs("电话：","Tel:","") }}{{getSetting.telPhone}}</li>
        <li>{{ $hs("手机/微信：","手机/微信:","") }}{{getSetting.mobile}}/{{ getSetting.weChatNo }}</li>
        <li>{{ $hs("WhatsApp/反馈：","Whatsapp/Facebook:","") }}{{getSetting.whatsApp}}/{{ getSetting.facebook }}</li>
        <li>{{ $hs("电子邮件：","Email : ","") }}{{getSetting.homeMail}}</li>
        <li>{{ $hs("友好链接：","Friendly Link: ","") }}{{ getSetting.twitter }}</li>
      </ul>
    </div>-->
    <!-- <div class="container contact_loash">
      <img src="../../assets/contact_loash.png" alt />
    </div> -->
    <div class="container leave-word">
      <div class="title">
        <img src="../../assets/liuyan.png" alt />
        <div style="margin-left: 10px;">{{ $hs("请留下您宝贵的意见或需求。","Please leave your valuable feedback or requirements","") }}</div>
      </div>
      <div class="form-box">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="top">
          <div class="flex">
            <el-form-item :label="$hs('你的名字','Name','Твое имя')" prop="name">
              <el-input v-model="form.name" :placeholder="$hs('请输入你的名字','Please Enter Your Name','Пожалуйста, введите свое имя')"></el-input>
            </el-form-item>
            <el-form-item :label="$hs('邮箱','Email','Электронная почта')" prop="email" required>
              <el-input
                v-model="form.email"
                :placeholder="$hs('请输入你的电子邮件','Please enter your email address.','Пожалуйста, введите свою почту')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$hs('国家','Country','стран')" prop="country">
              <el-input v-model="form.country" :placeholder="$hs('请输入你的国家','Please enter your country.','Пожалуйста, введите страну')"></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item :label="$hs('Skype','Skype','Skype')" prop="skype">
              <el-input v-model="form.skype" :placeholder="$hs('请输入你的Skype','Please enter your Skype.','Пожалуйста, введите ваш Skype')"></el-input>
            </el-form-item>
            <el-form-item :label="$hs('QQ','QQ','QQ')" prop="qq">
              <el-input v-model="form.qq" :placeholder="$hs('请输入你的qq','Please enter your QQ number.','Введите ваш qq, пожалуйста')"></el-input>
            </el-form-item>
            <el-form-item :label="$hs('地区','region','региональн')" prop="area">
              <el-input v-model="form.area" :placeholder="$hs('请输入你的地区','Please enter your region.','Введите область, пожалуйста')"></el-input>
            </el-form-item>
          </div>
          <el-form-item :label="$t('GA.MessageNeeds')" prop="content" required>
            <el-input
              type="textarea"
              v-model="form.content"
              :autosize="{ minRows: 8, maxRows: 10}"
              :placeholder="$hs('请输入你的需求','Please state your requirements.','Пожалуйста, введите ваши требования')"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="submit">
          <el-button class="btn" @click="submitForm('form')">{{$t('GA.Submit')}}</el-button>
          <el-button class="btn btnRest" @click="clearClose()">{{$hs("取消","Reset")}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from '@/api/login'
import { mapState, mapGetters } from 'vuex'
import { GetContactInfo } from '@/api/home'

export default {
  name: 'pageDetail',
  data() {
    return {
      form: {
        name: '',
        tel: '',
        email: '',
        content: '',
        country: "",
        area: "",
        skype: '',
        qq: ''
      },
      datas: {},
      rules: {
        name: [{ required: true, message: '请输入名字', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapGetters('setting', {
      getSetting: 'get_setting'
    })
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      GetContactInfo().then(res => {
        if (res.success) {
          this.datas = res.data
        }
      })
    },
    clearClose() {
      this.form = {
        name: '',
        tel: '',
        email: '',
        content: '',
        country: "",
        area: "",
        skype: '',
        qq: ''
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        console.log('valid :>> ', valid)
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t('GA.loading'),
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          Message(this.form)
            .then(res => {
              if (res.success) {
                this.$message.success(
                  this.$hs(
                    '提交成功',
                    'Submitted successfully',
                    'Presentación exitosa'
                  )
                )
                this.$refs[formName].resetFields()
                this.clearClose();
              } else {
                this.$message.error(
                  this.$hs(
                    '提交失败',
                    'Submission failed',
                    'Presentación fallida'
                  )
                )
              }

            })
            .catch(err => {
              this.$message.error(JSON.stringify(err))
            })
            .finally(() => {
              loading.close()
            })
        } else {
          this.$message.warning(
            this.$hs(
              '请填写您的名字、邮箱、需求',
              'Por favor, rellene su nombre, buzón, necesidades',
              'Please fill in your name, email address, and requirements'
            )
          )
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__label:before {
  color: #222222 !important;
  margin-right: 0px !important;
}
.images {
  position: relative;
  .images_contents {
    position: absolute;
    top: 174px;
    width: 800px;
    height: 112px;
    font-size: 20px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    line-height: 44px;
  }
}
.locash {
  display: flex;
  align-items: center;
  margin-top: 28px;
  .loacsh_title {
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    color: #222222;
    margin-left: 10px;
  }
}
.locashbox {
  display: flex;
  align-items: center;
  padding-left: 60px;
  margin-top: 22px;
  .line {
    width: 4px;
    height: 167px;
    background: #ff8469;
  }
  ul li {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #222222;
    line-height: 36px;
    margin-left: 12px;
  }
}

.contact_loash {
  margin-top: 40px;
  margin-bottom: 80px;
}
.contact-box {
  min-height: 400px;
}
.detail {
  margin-top: 28px;
  :deep(img) {
    max-width: 100%;
  }
}

.leave-word {
  margin-top: 20px;
  .title {
    font-size: 22px;
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    font-weight: 700;
    text-align: left;
    color: #222222;
    line-height: 36px;
    display: flex;
    align-items: center;
  }
  .msg {
    font-size: 16px;
    color: #333c4f;
    margin: 10px 0 0 0;
  }
  .form-box {
    padding: 20px 0 40px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    :deep(.el-form-item) {
      width: 380px;
    }
  }
  :deep(.el-form-item) {
    margin: 10px 0px 0px !important;
    .el-form-item__label,
    .el-form-item__content {
      line-height: 36px;
      padding: 0px !important;
    }
    .el-form-item__error {
      display: none;
    }
  }
  .submit {
    margin: 30px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .btn {
      width: 140px;
      height: 42px;
      background: #ff0000;
      border: 1px solid #ff0000;
      color: #ffffff;
    }
    .btnRest {
      background: #dcdee2;
      color: #999999;
      border: 1px solid #dcdee2;
    }
  }
}
</style>
